module.exports = __webpack_public_path__ + "3867a024b61e8a167fc238be941cd5f4.svg";